<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 41.1 41.1"
    style="enable-background:new 0 0 41.1 41.1;"
    xml:space="preserve"
    class="boxonlysvg"
  >
    <svg:style type="text/css" scoped>
      .well-radial12 .st2 {
        fill: #ffffff;
      }
      .well-radial12 .st3 {
        fill: none;
      }
      .well-radial12 .stblack {
        fill: #000000;
      }
    </svg:style>
    <g class="megacontainer">
      <!-- Outer puck body with registration notch (matches clipped/unclipped) -->
      <path
        class="st0"
        d="M25.8,0.7c0,0.3,0.1,0.6,0.1,0.9c0,2.9-2.4,5.3-5.3,5.3s-5.3-2.4-5.3-5.3c0-0.3,0-0.6,0.1-0.9   C6.5,3,0,11,0,20.5C0,31.8,9.2,41,20.5,41S41,31.8,41,20.5C41.1,11,34.6,3,25.8,0.7z"
      />

      <!-- Inner well field (uses darkColor via st1) -->
      <circle class="st1" cx="20.55" cy="20.55" r="14.5" />

      <!-- 12 white radial walls between slots (offset 15deg so they sit
           between marker positions, not under them) -->
      <g class="dividers">
        <rect
          v-for="n in 12"
          :key="'div-' + n"
          class="st2"
          :transform="`rotate(${(n - 1) * 30 + 15} 20.55 20.55)`"
          x="20.3"
          y="6.05"
          width="0.5"
          height="9"
        />
      </g>

      <!-- 12 grid marks (the copper rings shown black when present).
           showGridClips is expected to be a 12-element boolean array. -->
      <g class="gridpieces">
        <ellipse
          v-for="n in 12"
          :key="'mark-' + n"
          :class="{ hidden: !showGridClips[n - 1] }"
          class="stblack"
          :transform="`rotate(${(n - 1) * 30} 20.55 20.55)`"
          cx="20.55"
          cy="10.55"
          rx="1.2"
          ry="3.2"
        />
      </g>

      <!-- Central hub: white outer ring with darkColor inner hole -->
      <circle class="st2" cx="20.55" cy="20.55" r="4" />
      <circle class="st1" cx="20.55" cy="20.55" r="1.6" />

      <!-- Boundary circle (same role as in clipped/unclipped) -->
      <circle class="st3" cx="20.5" cy="20.5" r="20.5" />
    </g>
  </svg>
</template>
<script>
export default {
  props: ["color", "darkColor", "wellNumber", "showGridClips"],
};
</script>
